import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import {
    Cards,
    Careers,
    Carousel,
    Hero,
    LiftedBanner,
    SocialProof,
    HeroTeam24Promotion
} from "./sections";
import {
    CareersSection,
    AtlassianIntelligence,
    CustomerStories,
    GetStartedCTA,
    HeroJiraCTA,
    Integrations,
    ScrollPinnedSections,
    Tabs,
    Team24Promo,
    Teams
} from "./sections-v2";

export const HomePageTemplate = () => {
    const isTeam24Homepage = FeatureGates.getExperimentValue(
        "wac-homepage-team24-rollout",
        "ShowNewHomepage",
        false
    );

    const isTeam24PromotionHero = FeatureGates.checkGate(
        "wac-team-24-promotion-hero-and-banner"
    );

    if (isTeam24Homepage) {
        return (
            <UFOSegment name="home-page">
                <div>
                    <div>
                        <h2>global navigation</h2>
                        <hr />
                    </div>
                    <HeroJiraCTA />
                    <ScrollPinnedSections />
                    <AtlassianIntelligence />
                    <Teams />
                    <Tabs />
                    <Integrations />
                    <CustomerStories />
                    <Team24Promo />
                    <CareersSection />
                    <GetStartedCTA />
                    <div>
                        <h2>global footer</h2>
                    </div>
                </div>
            </UFOSegment>
        );
    }
    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                {isTeam24PromotionHero ? <HeroTeam24Promotion /> : <Hero />}
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
